import { useTranslation } from '@lyearn/i18n';
import { PlusOutline } from '@lyearn/icons';
import { LinkButton } from '@lyearn/ui';

import { AddMicroSkillProps } from './types';

const AddMicroSkill = (props: AddMicroSkillProps) => {
  const { onClick } = props;
  const { t } = useTranslation();

  return (
    <LinkButton
      StartIcon={PlusOutline}
      className="flex h-[6rem] w-full justify-start py-2 px-4 ps-20"
      color={'internal'}
      typography={{ variant: 'label-01' }}
      onClick={() => onClick?.()}>
      {t('SkillMatrix:MicroSkills.AddMicroSkill')}
    </LinkButton>
  );
};

export default AddMicroSkill;
